/** Google API Services User Data Policy (Limited Use). */
export const GOOGLE_API_USER_DATA_POLICY_URL =
  "https://developers.google.com/terms/api-services-user-data-policy";

/** Marketing help: revoke Google access, disconnect mailboxes, account data. */
export const HELP_GOOGLE_ACCESS_URL = "https://flipmail.ai/help/google-access/";
